<template>
    <div class="i_status_footer">
        <div class="status_footer_check">
            <div class="check_wrap">
                <el-checkbox v-model="termsCheck" @change="changeCheck"
                             :disabled="itemData.isAuctioning">
<!--                    <span class="item_text_span bold"-->
<!--                          @click="openModal('terms-modal','productSell')">{{ $t('product_sell_terms') }}</span>-->
                    <span v-html="$t('product_check_terms')"></span>
                </el-checkbox>
            </div>
        </div>

        <div class="save_btn one_btn" @click="checkTerms('limits')">{{ $t('save') }}
        </div>
        <div class="caption_check">
            <div class="mt10" v-if="showTermsMsg"><p>{{ $t('caption_check') }}</p></div>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";

export default {
    name: "ItemLimitsSaveLayout",
    mixins: [],
    components: {},
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        checkValidator: {
            default: () => {
            }, type: Function
        },
        itemData: {
            default: () => {
            }, type: Object
        },
        itemClass: {default: null,}
    },
    data() {
        return {
            termsCheck: false,
            showTermsMsg: false,
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        isItemData() {
            return !util.isEmpty(this.itemData);
        },
        changeCheck() {
            if (this.showTermsMsg) {
                this.showTermsMsg = false;
            }
        },
        openModal(name, type) {
            this.$modal.show(name, {termsType: type});
        },
        checkTerms(itemType) {
            if (!this.termsCheck) {
                this.showTermsMsg = true;
                return false;
            }
            this.showTermsMsg = false;
            this.save(itemType)
        },
        save(itemType) {
            this.setComponentData('itemType', itemType);
            this.checkValidator();
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
